import {
  BankPennylessVerificationDetails,
  BankVerification,
  TinVerificationDetails,
  validateAadhaar,
  validateDrivingLicense,
  validatePanComprehensive,
  validatePanLite,
  validateRCText,
  validateVoterId,
  verifyAadhaarUANLinkDetails,
  VerifyAadharPanLink,
  VerifyCorporateDetails,
  VerifyCorporateGstInDetails,
  VerifyCreditReport,
  VerifyCreditReportPdf,
  VerifyDirectPhone,
  VerifyDINDetails,
  VerifyEchallan,
  VerifyEcourtsSearchDetails,
  VerifyElectricityBillDetails,
  VerifyEmploymentHistoryUrn,
  VerifyFastag,
  VerifyFastagRc,
  VerifyFindUPIID,
  VerifyMobileToBank,
  VerifyMobileTORc,
  verifyMobileToUan,
  VerifyPanToUAN,
  VerifyPassport,
  VerifyRationCard,
  VerifyRcToMobileNo,
  VerifyTan,
  VerifyTanCompanySearchDetails,
  VerifyTelecom,
  VerifyUdyamAadhaarDetails,
  VerifyFSSAIDetails,
  VerifyGSTVerificationAdvance,
  VerifyPanAdvance,
  VerifyPanUdyamMSMEStatus,
  VerifyEmploymentHistorAdvance,
  VerifyCreditReportV2,
  CCRVGenerateRequest,
  CCRVVerifyRequest,
  aadhaarDetailsGenerateOtp,
  aadhaarDetailsVerifyOtp,
  employmentCompositeApi,
  employmentHistoryWageMonthApi,
} from './ApiEndpoints';

export const apiMap = {
  AADHAAR: validateAadhaar,
  AADHAAR_OTP_GENERATION: verifyAadhaarUANLinkDetails,
  DRIVING_LICENSE: validateDrivingLicense,
  VOTER_ID: validateVoterId,
  RCTEXT: validateRCText,
  PAN_LITE: validatePanLite,
  PAN_COMPREHENSIVE: validatePanComprehensive,
  BANK_VERIFICATION: BankVerification,
  BANK_VERIFICATION_PENNYLESS: BankPennylessVerificationDetails,
  CORPORATE_CIN: VerifyCorporateDetails,
  CORPORATE_GSTIN: VerifyCorporateGstInDetails,
  CREDIT_REPORT: VerifyCreditReport,
  CREDIT_REPORT_PDF: VerifyCreditReportPdf,
  ECOURT_CNR: VerifyEcourtsSearchDetails,
  DIRECTOR_PHONE: VerifyDirectPhone,
  ELECTRICITY_BILL_DETAILS: VerifyElectricityBillDetails,
  EMPLOYMENT_HISTORY_UAN: VerifyEmploymentHistoryUrn,
  EMPLOYMENT_HISTORY_ADVANCE: VerifyEmploymentHistorAdvance,
  FASTAG_RC: VerifyFastagRc,
  FASTAG_VERIFICATION: VerifyFastag,
  FIND_UPI_ID: VerifyFindUPIID,
  MOBILE_TO_RC: VerifyMobileTORc,
  MOBILE_TO_BANK: VerifyMobileToBank,
  PAN_TO_UAN: VerifyPanToUAN,
  PAN_ADVANCE_VERIFICATION: VerifyPanAdvance,
  PASSPORT: VerifyPassport,
  RC_MOBILE_NUMBER: VerifyRcToMobileNo,
  RATION_CARD: VerifyRationCard,
  TAN: VerifyTan,
  TAN_VERIFICATION: VerifyTan,
  TAN_COMPANY_SEARCH: VerifyTanCompanySearchDetails,
  TELECOM_VERIFICATION: VerifyTelecom,
  TIN_VERIFICATION: TinVerificationDetails,
  UDYOG_AADHAAR: VerifyUdyamAadhaarDetails,
  ECHALLAN: VerifyEchallan,
  AADHAAR_PAN_LINK_CHECK: VerifyAadharPanLink,
  AADHAAR_TO_UAN: verifyAadhaarUANLinkDetails,
  MOBILE_TO_UAN: verifyMobileToUan,
  DIN_VERIFICATION: VerifyDINDetails,
  CREDIT_REPORT_V2: VerifyCreditReportV2,
  FSSAI_VERIFICATION: VerifyFSSAIDetails,
  GST_VERIFICATION_ADVANCE: VerifyGSTVerificationAdvance,
  PAN_UDYAM_MSME_STATUS: VerifyPanUdyamMSMEStatus,
  CCRV_GENERATE_REQUEST: CCRVGenerateRequest,
  CCRV_VERIFY_REQUEST: CCRVVerifyRequest,
  AADHAAR_DETAILED_GENERATE_OTP: aadhaarDetailsGenerateOtp,
  AADHAAR_DETAILED_VERIFY_OTP: aadhaarDetailsVerifyOtp,
  EMPLOYMENT_COMPOSITE_API: employmentCompositeApi,
  EMPLOYMENT_HISTORY_WAGE_MONTH: employmentHistoryWageMonthApi,
};
